export interface ChangelogEntry {
  title: string;
  date: string;
  slug: string;
  content: string;
  language?: string;
}

import { LanguageCode } from '@/modules/common/types';

import changelog20250820WelcomeDe from './2025-08-20-welcome-to-mavue-de.md?raw';
import changelog20250820WelcomeEn from './2025-08-20-welcome-to-mavue-en.md?raw';
import changelog20250827De from './2025-08-27-changelog-feature-de.md?raw';
import changelog20250827En from './2025-08-27-changelog-feature-en.md?raw';
import changelog20250901TemplateEditingDe from './2025-09-01-template-editing-de.md?raw';
import changelog20250901TemplateEditingEn from './2025-09-01-template-editing-en.md?raw';

const parseFrontmatter = (content: string): { frontmatter: any; content: string } => {
  const frontmatterRegex = /^---\s*\n([\s\S]*?)\n---\s*\n([\s\S]*)$/;
  const match = content.match(frontmatterRegex);

  if (!match) {
    return { frontmatter: {}, content };
  }

  const frontmatterText = match[1];
  const markdownContent = match[2];

  const frontmatter: any = {};
  frontmatterText.split('\n').forEach((line) => {
    const colonIndex = line.indexOf(':');
    if (colonIndex > 0) {
      const key = line.substring(0, colonIndex).trim();
      const value = line
        .substring(colonIndex + 1)
        .trim()
        .replace(/^['"]|['"]$/g, '');
      frontmatter[key] = value;
    }
  });

  return { frontmatter, content: markdownContent };
};

const createChangelogEntry = (rawContent: string): ChangelogEntry => {
  const { frontmatter, content } = parseFrontmatter(rawContent);
  return {
    title: frontmatter.title || 'Untitled',
    date: frontmatter.date || '',
    slug: frontmatter.slug || '',
    content: content.trim(),
    language: frontmatter.language || 'en',
  };
};

const allChangelogs: ChangelogEntry[] = [
  createChangelogEntry(changelog20250820WelcomeEn),
  createChangelogEntry(changelog20250820WelcomeDe),
  createChangelogEntry(changelog20250827En),
  createChangelogEntry(changelog20250827De),
  createChangelogEntry(changelog20250901TemplateEditingEn),
  createChangelogEntry(changelog20250901TemplateEditingDe),
].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

export const changelogs = allChangelogs;

export const getChangelogsByLanguage = ({
  language,
}: {
  language: LanguageCode;
}): ChangelogEntry[] => {
  return allChangelogs.filter((changelog) => changelog.language === language);
};

export const getChangelogBySlug = ({
  slug,
  language,
}: {
  slug: string;
  language: LanguageCode;
}): ChangelogEntry | undefined => {
  return allChangelogs.find(
    (changelog) => changelog.slug === slug && changelog.language === language
  );
};

export const getLatestChangelog = ({
  language,
}: {
  language: LanguageCode;
}): ChangelogEntry | undefined => {
  const languageChangelogs = getChangelogsByLanguage({ language });
  return languageChangelogs[0];
};
